import type {
  Region,
  RegionDetail,
  RegionPaginationParams,
  CreateRegionRequest,
  UpdateRegionRequest,
  Paginated,
} from '../types/regions.types';
import type { IHttpResponse } from '@/core/api/HttpClient';
import httpClient from '@/core/api/createAxiosHttpClient';

export const regionsApi = {
  getRegions: async (
    pagination: RegionPaginationParams = {},
  ): Promise<IHttpResponse<Paginated<Region>>> => {
    const {
      page = 1,
      pageSize = 10,
      searchTerm,
      isActive,
      countryIds,
      selector,
      parentId,
      getAllLevels,
      expandCountryHierarchy,
    } = pagination;
    const params: Record<string, unknown> = { page, pageSize };

    if (searchTerm) params.searchTerm = searchTerm;
    if (isActive !== undefined) params.isActive = isActive;
    if (countryIds && countryIds.length > 0) params.countryIds = countryIds;
    if (selector !== undefined) params.selector = selector;
    if (parentId) params.parentId = parentId;
    if (getAllLevels !== undefined) params.getAllLevels = getAllLevels;
    if (expandCountryHierarchy) params.expandCountryHierarchy = true;

    return httpClient.get<Paginated<Region>>('/admin/regions', { params });
  },

  getRegionById: async (id: string): Promise<IHttpResponse<RegionDetail>> => {
    return httpClient.get<RegionDetail>(`/admin/regions/${id}`);
  },

  createRegion: async (data: CreateRegionRequest): Promise<IHttpResponse<Region>> => {
    return httpClient.post<CreateRegionRequest, Region>('/admin/regions', data);
  },

  updateRegion: async (id: string, data: UpdateRegionRequest): Promise<void> => {
    await httpClient.put(`/admin/regions/${id}`, data);
  },

  deleteRegion: async (id: string): Promise<IHttpResponse<void>> => {
    return httpClient.delete<void>(`/admin/regions/${id}`);
  },

  changeRegionStatus: async (id: string, isActive: boolean): Promise<IHttpResponse<void>> => {
    const response = await httpClient.patch<{ isActive: boolean }>(`/admin/regions/${id}/status`, {
      isActive,
    });
    return { ...response, data: undefined as unknown as void };
  },
};
